import { createIcon, Path } from './index';

export const IconUsersWhite = createIcon({
  title: 'A user with another behind them.',
  viewBox: '0 0 32 32',
  path: [
    <Path
      d="M21.3337 28V25.3333C21.3337 23.9188 20.7718 22.5623 19.7716 21.5621C18.7714 20.5619 17.4148 20 16.0003 20H8.00033C6.58584 20 5.22928 20.5619 4.22909 21.5621C3.2289 22.5623 2.66699 23.9188 2.66699 25.3333V28"
      fill="none"
      stroke="#FFFFFF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />,
    <Path
      d="M12.0003 14.6667C14.9458 14.6667 17.3337 12.2789 17.3337 9.33335C17.3337 6.38782 14.9458 4.00002 12.0003 4.00002C9.05481 4.00002 6.66699 6.38782 6.66699 9.33335C6.66699 12.2789 9.05481 14.6667 12.0003 14.6667Z"
      fill="none"
      stroke="#FFFFFF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />,
    <Path
      d="M29.3337 28V25.3333C29.3336 24.2274 28.9874 23.1533 28.3455 22.2667C27.7036 21.38 26.8002 20.7286 25.7603 20.4067"
      fill="none"
      stroke="#FFFFFF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />,
    <Path
      d="M20.427 4.40667C21.4687 4.72616 22.374 5.37716 23.0175 6.26416C23.661 7.15116 24.0084 8.22656 24.0084 9.33334C24.0084 10.4401 23.661 11.5155 23.0175 12.4025C22.374 13.2895 21.4687 13.9405 20.427 14.26"
      fill="none"
      stroke="#FFFFFF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />,
  ],
});
